import HttpRequest from './axios'
import config from '@/config';

const baseUrl = config.baseUrl.pro
const axios = new HttpRequest(baseUrl)

export default axios
